const WorkPromotion = () =>
  import('@/views/main/workpromotion/manage/Manage.vue')
export default {
  path: '/main/workpromotion/manage',
  name: 'WorkPromotion',
  component: WorkPromotion,
  children: []
}
